export default __webpack_public_path__ + "ui/assets/img/mail-green-24.svg";